export interface KpiStatCardProps {
	label: string
	value: string
	hint?: string
	iconClass: string
	accentClass?: string
	delta?: string
	loading?: boolean
	className?: string
	onClick?: () => void
}

export const KpiStatCard = ({
	label,
	value,
	hint,
	iconClass,
	accentClass = 'text-primary',
	delta,
	loading,
	className = '',
	onClick,
}: KpiStatCardProps) => {
	const deltaLine =
		delta && !loading ? (delta.includes('vs last month') ? delta : `${delta} vs last month`) : null

	const Tag = onClick ? 'button' : 'article'

	return (
		<Tag
			type={onClick ? 'button' : undefined}
			onClick={onClick}
			className={`flex min-w-0 flex-col rounded-app border border-border/60 bg-card/60 p-5 text-left text-card-foreground ${
				onClick ? 'transition-colors hover:bg-secondary/20' : ''
			} ${className}`.trim()}
		>
			<div className="mb-3 flex items-center justify-between gap-2">
				<span className="truncate text-[11px] font-semibold uppercase tracking-wide text-muted-foreground">{label}</span>
				<div className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-secondary/80 ${accentClass}`}>
					<i className={`${iconClass} text-base`} aria-hidden />
				</div>
			</div>
			{loading ? (
				<div className="h-9 w-24 animate-pulse rounded-app bg-muted/60" aria-busy />
			) : (
				<p className="font-display text-2xl font-semibold tracking-tight text-foreground">{value}</p>
			)}
			{deltaLine ? <p className="mt-1 text-xs text-success">{deltaLine}</p> : null}
			{hint ? <p className="mt-1 text-xs font-medium text-muted-foreground">{hint}</p> : null}
		</Tag>
	)
}
